import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { NavigationPath } from '@models/routes'
import { useAuthenticatedUser } from '@components/hooks/use-authenticated-user'
import { HousekeepingCleaningOrderType } from '@modules/housekeeping/models'

export const HousekeepingCleaningOrdersView: React.FC = () => {
  const user = useAuthenticatedUser()

  const navigate = useNavigate()

  React.useEffect(() => {
    navigate(
      NavigationPath.HousekeepingCleaningOrdersWithParams.replace(':resort_id', String(user.resorts[0].id)).replace(
        ':tab',
        String(HousekeepingCleaningOrderType.TO_ORDER),
      ),
    )
  }, [])

  return null
}
